var render = function render(){var _vm=this,_c=_vm._self._c;return _c('span',{staticClass:"dui-explicit-content space-bottom-none"},[_vm._v("\n  Explicit\n")])
}
var staticRenderFns = []

export { render, staticRenderFns }